export enum ComplianceStatuses {
  Approved = 'approved',
  Unapproved = 'unapproved',
}
